import React from "react";
import ReactGA from 'react-ga';
import Link from "react-router-dom/Link";
import Page from "../Page";

import restartSVG from "img/restart.svg";

export default function Introduction({ resetData }) {
  ReactGA.pageview('/introduction')
  return (
    <Page>
      <div className="introduction-page">
        <div className="introduction-page__restart-block">
          <Link
            to={{ pathname: "/login", state: { prev: true } }}
            className="introduction-page__restart-btn"
            href="#"
            onClick={resetData}
          >
            <img
              className="introduction-page__restart-icon"
              src={restartSVG}
              alt=""
            />
            <span>Restart</span>
          </Link>
        </div>

        <div className="introduction-page__arms-block">
          <ul className="introduction-page__arms-list">
            <li>
              <h1>A</h1>
              <p className="introduction-page__arms-list-header">Access</p>
              <p>
                Access should be given to all applicable associates, not just
                FES/HC.
              </p>
            </li>

            <li>
              <h1>R</h1>
              <p className="introduction-page__arms-list-header">Replenish</p>
              <p>
                Replenish pick ticket tear pads in all merchandising locations
                with one pad on fixture and one stored behind fixture.
              </p>
            </li>

            <li>
              <h1>M</h1>
              <p className="introduction-page__arms-list-header">Manage</p>
              <p>
                Manage physical on hand inventory in cage; same as in aisle.
              </p>
            </li>

            <li>
              <h1>S</h1>
              <p className="introduction-page__arms-list-header">Secure</p>
              <p>
                Secure cage at all times with a combination lock, not keyed.
              </p>
            </li>
          </ul>
        </div>

        <div className="introduction-page__text-block">
          <p className="bold introduction-page__header-text">
            Consistent execution of this process not only helps reduce
            theft-driven shrink, but it also drives sales! On the flip side,
            haphazard execution can hurt sales.
          </p>

          <p className="introduction-page__main-text">
            Let's solve some common pick ticket problems to ensure our customer
            has a seamless shopping experience and we can grow those sales!
          </p>
        </div>

        <div className="introduction-page__get-started-block">
          <Link
            to={{
              pathname: "/arrival",
              state: { prev: true }
            }}
            className="btn login-page__start-btn white"
          >
            <span className="white-background">Get started</span>
          </Link>
        </div>
      </div>
    </Page>
  );
}
